/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCurrencyItemRequestBuilder, WithCurrencyItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /creditcards/history
 */
export interface HistoryRequestBuilder extends BaseRequestBuilder<HistoryRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.creditcards.history.item collection
     * @param currencyId Unique identifier of the item
     * @returns {WithCurrencyItemRequestBuilder}
     */
     byCurrencyId(currencyId: string) : WithCurrencyItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const HistoryRequestBuilderUriTemplate = "{+baseurl}/creditcards/history";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const HistoryRequestBuilderNavigationMetadata: Record<Exclude<keyof HistoryRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCurrencyId: {
        requestsMetadata: WithCurrencyItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["currencyId"],
    },
};
/* tslint:enable */
/* eslint-enable */
